import axios from 'axios';

const API_BASE_URL = 'https://api.ummahfy.com/api';
const API_KEY = 'test'; // We'll change this to use environment variable later

export const fetchEvents = async (organization) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/events`, {
      headers: {
        'x-api-key': API_KEY
      }
    });

    // Filter events for the specific organization
    console.log(response.data)
    const orgEvents = response.data.filter(event => event.organization === organization);
    
    // Process events to handle frequency
    return orgEvents.map(event => ({
      ...event,
      // If frequency is "Once", only use the first date, otherwise use all dates
      dates: event.frequency === "Once" ? [event.dates[0]] : event.dates
    }));

  } catch (error) {
    console.error('Error fetching events:', error);
    throw error;
  }
};